import React from 'react';
import './InvalidToken.css'; 

const InvalidToken = () => {
  return (
    <div className="invalid-token-container">
      <div className="invalid-token-content">
        <h2>Link Invalid</h2>
        <p>
          Oops! It seems like this link is outdated or broken. Please contact our support team for assistance.
        </p>
        <div className="invalid-token-action">
          <a href="mailto:support@example.com" className="contact-link">Contact Support</a>
        </div>
      </div>
    </div>
  );
};

export default InvalidToken;
